import { useState } from "react";
import type { ApiError } from "@entrilia/shared/api/types";

export type ExecutionState =
  | {
      status: "idle";
    }
  | {
      status: "in-progress";
    }
  | {
      status: "success" | "warning";
      text?: string;
      details?: string[];
      // Overrides what the copy button copies. When unset it falls back to the details lines.
      copyText?: string;
      links?: Array<{ label: string; href: string }>;
    }
  | {
      status: "error";
      text?: string;
      error?: ApiError;
      errorMessage?: string;
    };

export const useExecutionState = () => {
  const [executionState, setExecutionState] = useState<ExecutionState>({ status: "idle" });

  return {
    executionState,
    setExecutionState,
  };
};
